<template>
	<div class="data-row flex-1 flex-centerize">
		<SettingsManageUsersInfoAvatar :user="user" :size="size" />
		<div class="row-details flex-1 mr-1">
			<div>
				<div class="row-title">{{ userName }}</div>
				<div class="row-description" v-if="isShowEmail">{{ user.email }}</div>
			</div>
		</div>
		<slot />
		<ProjectRoleSelector :readonly="isProjectOwner" :projectId="projectId" :role="role" :user="user" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getProject } from '@/store/modules/projects/getters';
import ProjectRoleSelector from './ProjectRoleSelector.vue';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar';
import ProjectsService from '@/utils/projects-service';

export default {
	name: 'UserDataRow',
	components: {
		SettingsManageUsersInfoAvatar,
		ProjectRoleSelector,
	},
	props: {
		me: { type: Object },
		user: { type: Object, required: true },
		size: { type: Number, default: 38 },
		isShowEmail: { type: Boolean },
		userData: { type: Object },
		projectId: { type: Number },
	},
	computed: {
		...mapGetters([getProject.fullPath]),
		project() {
			return this[getProject.fullPath](this.projectId);
		},
		userName() {
			if (!this.user) return '';
			if (this.isShowEmail) {
				return this.user.name;
			}
			return this.user.name || this.user.email;
		},
		role() {
			return this.userData?.role;
		},
		isProjectOwner() {
			return ProjectsService.isProjectOwner(this[getProject.fullPath](this.projectId), this.user.user_id);
		},
	},
};
</script>

<style scoped lang="scss">
@import './data-row.scss';
</style>
